import { Api } from "../config/request";

export default {
  getLocalityList(queryParams) {
    return Api.get(`/locations/locality${queryParams}`);
  },
  getLocality(payload) {
    const id = payload.id;
    return Api.get(`/locations/locality/${id}`);
  },
  updateLocality(id, payload) {
    return Api.put(`/locations/locality/${id}`, payload);
  },
  createLocality(payload) {
    return Api.post("/locations/locality", payload);
  },
};
